// MagneticSensor.jsx
import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/MagneticSensor.css';

import { FaFilePdf, FaChevronRight,FaEnvelope } from 'react-icons/fa';
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';


import G_Magnetic_Cylinder_SensorPdf from '../assets/G_Magnetic_Cylinder_Sensor.pdf'
import MagneticSensorSpecificationPdf from '../assets/Magnetic Sensor Specification.pdf'
import MagnaticSensorMain1 from '../assets/MagnaticSensorMain1.png'
import MagneticSpecsImg from '../assets/Magnetic Sensor Specification IMG.png'
import MS1 from '../assets/MS1.jpg'
import MS2 from '../assets/MS2.jpg'
import MS3 from '../assets/MS3.jpg'
import MS4 from '../assets/MS4.jpg'
import MS5 from '../assets/MS5.jpg'
import MS6 from '../assets/MS6.jpg'
import MS7 from '../assets/MS7.jpg'
import MS8 from '../assets/MS8.jpg'








import MagneticSensorsPdf from '../assets/Magnetic/Magnetic Sensors.pdf'
import HighPrecisionCylinderSensorsCatalogPdf from '../assets/Magnetic/High Precision Cylinder Sensors Catalog.pdf'
import EconomicalCylinderSensorCatalogPdf from '../assets/Magnetic/Economical Cylinder Sensor Catalog.pdf'
import EnvironmentalResistanceCylinderSensorsPdf from '../assets/Magnetic/Environmental Cylinder Sensor Catalog.pdf'
import CombinedCylinderSensorCatalogPdf from '../assets/Magnetic/Combined Cylinder Sensor Catalog.pdf'
import MagneticProximitySensorsPdf from '../assets/Magnetic/Magnetic Proximity Sensors.pdf'
import LinearSensorsPdf from '../assets/Magnetic/Linear Sensors Catalog.pdf'






export default function MagneticSensor() {
  const [activeTab, setActiveTab] = useState("magnetic");
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


const renderMagneticSensors = () => (
  <div className="sensor-cards">
    <div className="card">
      <img src={MS1} alt="Magnetic Sensors" />
      <h3>Magnetic Sensors</h3>
      <ul>
        <li>Small size, long duration, high sensitivity and long sensing distance</li>
        <li>Response Time at 5 μ s - Fastest response time</li>
        <li>S-pole (standard magnet pole)</li>
      </ul>
      <a href={MagneticSensorsPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
    </div>

    <div className="card">
      <img src={MS2} alt="High Precision" />
      <h3>High Precision Positioning with Reliable Performance</h3>
      <ul>
        <li>High positioning precision, reliable performance</li>
        <li>Vibration and heat resistance</li>
        <li>Response time less than 5 μs (3-wire type)</li>
      </ul>
      <a href={HighPrecisionCylinderSensorsCatalogPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
    </div>

    <div className="card">
      <img src={MS3} alt="Economical Cylinder" />
      <h3>Economical Cylinder Sensor</h3>
      <ul>
        <li>High positioning accuracy, reliable performance</li>
        <li>Maximum switching frequency up to 1000 Hz</li>
      </ul>
      <a href={EconomicalCylinderSensorCatalogPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
    </div>

    <div className="card">
      <img src={MS4} alt="Environmental Cylinder" />
      <h3>Environmental Resistance Cylinder Sensors</h3>
      <ul>
        <li>Full metal material, reliable performance</li>
        <li>Vibration and heat resistance</li>
        <li>Maximum switching frequency up to 1000HZ</li>
      </ul>
      <a href={EnvironmentalResistanceCylinderSensorsPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
    </div>

    <div className="card">
      <img src={MS5} alt="Combined Sensors" />
      <h3>Combined Cylinder Sensors</h3>
      <ul>
        <li>With different brackets to fit almost all cylinder sensors in the market</li>
        <li>Suitable for replacing contact cylinder sensors</li>
        <li>Suitable for C-slot, T-slot, hoop, guide rail, tie rod and other installation environments</li>
      </ul>
      <a href={CombinedCylinderSensorCatalogPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
    </div>

    <div className="card">
      <img src={MS6} alt="Magnetic Proximity" />
      <h3>Magnetic Proximity Sensors</h3>
      <ul>
        <li>Proximity sensors that detect ferromagnetic materials, such as iron</li>
        <li>No reaction to aluminum and non-ferromagnetic stainless steel</li>
        <li>Can be used on CNC machines, refrigerating equipments, on-standard positioning equipments etc.</li>
      </ul>
      <a href={MagneticProximitySensorsPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
    </div>

    <div className="card">
      <img src={MS7} alt="Door Sensor" />
      <h3>Door Sensors</h3>
      <ul>
        <li>Small size, excellent sensitivity</li>
        <li>Non-contact, long life and highly reliable</li>
        <li>With magnetic hole (12), it still performs well even fixed inside iron doors</li>
      </ul>
      {/* <a href={G_Magnetic_Cylinder_SensorPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a> */}
    </div>

    <div className="card">
      <img src={MS8} alt="Linear Sensor" />
      <h3>Linear Sensors</h3>
      <ul>
        <li>Output voltage varies linearly with magnetic force</li>
        <li>Output voltage changes linearly according to the movements of magnets</li>
        <li>It can be used from low to high temperature</li>
      </ul>
      <a href={LinearSensorsPdf} target="_blank" rel="noopener noreferrer"><button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Download</button></a>
    </div>
    
  </div>
);

const renderTechnicalSpecs = () => (
  <div className="Magneticspecs-image-wrapper">
    <img
      src={MagneticSpecsImg}
      alt="Magnetic Sensor Technical Specifications"
      className="Magneticspecs-img"
    />

    <div className="Magneticspecs-download-btn">
      <a
        href={MagneticSensorSpecificationPdf}
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="download-catalog-btn">
          <FaFilePdf style={{ marginRight: '8px' }} /> Download
        </button>
      </a>
    </div>
  </div>
);

  return (
    <div className="MagneticSensor-wrapper">
      <Header />

      <div className="hero-banner17">
        <div className="hero-banner17-content">
          <h1>HIGH-PRECISION-MAGNETIC-SENSOR</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>High-Precision-Magnetic-Sensor</span>
          </div>
        </div>
      </div>

<div className="magnetic-intro">
  <div className="magnetic-intro-img">
    <img src={MagnaticSensorMain1} alt="Magnetic Sensor Overview" />
  </div>
  <div className="magnetic-intro-text">
    <h2>High Precision Magnetic Sensor</h2>
    <li>Non-contact,reliable and solid,abundant types</li>
    <li>Micron response speed,high measurement sensitivity</li>
    <li>High positioning accuracy and reliable performance</li>
    <li>Small size, long duration and high sensitivity.</li>
    <li>Extreme response speed at micron level.</li>
    
    <div className="sensor-buttons">
      <a href={G_Magnetic_Cylinder_SensorPdf} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>
      </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
                {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

    </div>
  </div>
          

</div>


      <div className="sensor-tabs">
        <button
          className={activeTab === "magnetic" ? "active" : ""}
          onClick={() => setActiveTab("magnetic")}
        >
          Magnetic / Cylinder Sensor
        </button>
        <button
          className={activeTab === "specs" ? "active" : ""}
          onClick={() => setActiveTab("specs")}
        >
          Technical Specifications
        </button>
      </div>

      <div className="sensor-content">
        {activeTab === "magnetic" ? renderMagneticSensors() : renderTechnicalSpecs()}
      </div>

      <Footer />
    </div>
  );
}
